
<template>
    <button-button :type="type" class="btn" :disabled="disabled || spinning">
        <div class="spin-content">
            <div v-show="spinning" class="spin-icon me-2">
                <fa-icon icon="spinner" class="fa-spin" />
            </div>
            <div class="spin-text">
                <slot/>
            </div>
        </div>
    </button-button>
</template>

<style scoped lang="scss">
    .spin-content {
        display:flex;
        align-content: center;
        align-items: center;
        .spin-icon {
            flex-grow: 0;
            flex-shrink: 0;
        }
        .spin-text {
            flex-grow: 1;
            flex-shrink: 1;
        }
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    props: {
        type: { type: String, required: false, default: "button" },
        disabled: { type: Boolean, required: false, default: false },
        spinning: { type: Boolean, required: false, default: false },
    },
});

</script>
